import {snakeCase} from "lodash/string";
import Pluralize from 'pluralize';

const translations = () => {
    return [
        'color',
        'foliageComment',
        'labellingComment',
        'potColor',
        'damageComment',
        'cutStage',
        'cultivation',
        'leafQualityComment',
        'loadCarrier',
        'longExtension',
        'maturityComment',
        'maturityStage',
        'miscellaneousQualityComment',
        'cuttingQualityComment',
        'overallQualityComment',
        'performanceCheck',
        'headSizeComment',
        'pestQualityComment',
        'pestComment',
        'physiologicalComment',
        'presentationComment',
        'stickerPosition',
        'budQualityComment',
        'flowerOpeningComment',
        'boxPackagingComment',
        'consumableComment',
        'bunchingComment',
        'qualityGroup',
        'category',
        'group',
        'conclusion',
        'flowerLeafSizeComment',
        'flowerBudCountComment',
        'potMaterial',
        'shape',
        'reportScore',
        'country',

    ].sort();
}
const getTranslation = (name) => {
    const key = snakeCase(Pluralize(name)).toUpperCase();
    return `SETTINGS.${key}`;
}

export {translations, getTranslation};
